module.exports = girder_plugin_large_image;


//////////////////
// WEBPACK FOOTER
// external "girder_plugin_large_image"
// module id = 7
// module chunks = 0